<template>
    <main>
        <Banner :info="bannerInfo" />
        <TradeShow />
        <Carousel />
    </main>
</template>

<script>
import Banner from '@/components/Banner'
import TradeShow from './_tradeshow'
import Carousel from './_carousel'

export default {
    components: {
        Banner,
        TradeShow,
        Carousel
    },
    data() {
        return {
            bannerInfo: {
                src: require("@/assets/images/tradeshow/banner.jpg"),
                alt: "wipe clear explore more"
            }
        }
    },
}
</script>

<style>

</style>